var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.1,155.8l22.1,68h71.5l-57.8,42.1l22.1,68l-57.9-42l-57.9,42l22.2-68l-57.9-42.1H118L140.1,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.5,396.5l-16.9-20.8l-25,9.7l14.5-22.5L259.2,342l25.9,6.9l14.6-22.5l1.4,26.8l26,6.9l-25.1,9.6 L303.5,396.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.1,335.5l8-25.6l-21.9-15.5L350,294l7.9-25.6l8.7,25.4l26.8-0.3l-21.5,16l8.6,25.4l-21.9-15.5L337.1,335.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.4,187.9L370.6,212l19.2,18.7l-26.5-3.8l-11.8,24l-4.6-26.4l-26.6-3.8l23.8-12.5l-4.6-26.5l19.2,18.7 L382.4,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.2,114.9l-2,26.7l24.9,10.1l-26.1,6.4l-1.9,26.8L285,162.1l-26.1,6.4l17.3-20.5L262,125.3l24.9,10.1 L304.2,114.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.048ff2a4cb8de94c7357e1e3eee6fb48.svg";
export { ForwardRef as ReactComponent };